import React, { useState, useEffect } from "react";
import {
  Dialog, AppBar, Toolbar, IconButton, Typography, Slide,
  DialogContent, DialogActions, DialogTitle, Button,
} from "@mui/material";
import { Cancel } from "@mui/icons-material";
import StackInsumosForm from "./StackInsumosForm";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const StackInsumosDrawer = ({ open, handleClose, mode, variants }) => {
  const [isDirty, setIsDirty] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);

  // Resetear estado sucio al abrir el formulario
  useEffect(() => {
    if (open) setIsDirty(false);
  }, [open]);

  const handleCloseAttempt = () => {
    if (isDirty) {
      setConfirmOpen(true);
    } else {
      handleClose();
    }
  };

  const handleConfirmDiscard = () => {
    setConfirmOpen(false);
    setIsDirty(false);
    handleClose();
  };

  return (
    <>
      <Dialog
        fullScreen
        open={open}
        onClose={handleCloseAttempt}
        TransitionComponent={Transition}
        PaperProps={{
          sx: {
            display: "flex",
            flexDirection: "column",
          },
        }}
      >
        <AppBar
          position="sticky"
          sx={{
            background: "linear-gradient(135deg, #f43f5e 0%, #ec4899 100%)",
            flexShrink: 0,
          }}
          elevation={2}
        >
          <Toolbar>
            <Typography
              sx={{
                flex: 1,
                fontFamily: "'Poppins', sans-serif",
                fontWeight: 700,
                fontSize: "1rem",
                letterSpacing: "0.06em",
              }}
            >
              {mode === "POST" ? "Registrar Movimiento" : "Editar Movimiento"}
            </Typography>
            <IconButton edge="end" onClick={handleCloseAttempt} sx={{ color: "#fff" }}>
              <Cancel />
            </IconButton>
          </Toolbar>
        </AppBar>

        <StackInsumosForm
          mode={mode}
          handleClose={handleClose}
          variants={variants}
          onDirtyChange={setIsDirty}
        />
      </Dialog>

      {/* Confirmación al intentar cerrar con cambios no guardados */}
      <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle
          sx={{ fontFamily: "'Poppins', sans-serif", fontWeight: 700, color: "#be185d", pb: 1 }}
        >
          ¿Descartar cambios?
        </DialogTitle>
        <DialogContent>
          <Typography sx={{ fontFamily: "'Poppins', sans-serif", fontSize: "0.9rem", color: "#374151" }}>
            Tienes cambios sin guardar. Si cierras el formulario se perderán.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2.5, gap: 1 }}>
          <Button
            onClick={() => setConfirmOpen(false)}
            variant="outlined"
            sx={{
              borderColor: "#f43f5e", color: "#f43f5e",
              fontFamily: "'Poppins', sans-serif", fontWeight: 600,
              "&:hover": { borderColor: "#e11d48", background: "rgba(244,63,94,0.04)" },
            }}
          >
            Seguir editando
          </Button>
          <Button
            onClick={handleConfirmDiscard}
            variant="contained"
            sx={{
              background: "linear-gradient(135deg, #f43f5e 0%, #ec4899 100%)",
              fontFamily: "'Poppins', sans-serif", fontWeight: 600,
              "&:hover": { background: "linear-gradient(135deg, #e11d48 0%, #db2777 100%)" },
            }}
          >
            Descartar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default StackInsumosDrawer;
